var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9943 11.3586L0.950498 1.29781C0.726058 1.04794 0.726058 0.64309 0.950524 0.393361C1.17496 0.143659 1.53888 0.143631 1.76345 0.393361L10.805 10.4526L10.8049 4.1139C10.805 3.76074 11.0623 3.47447 11.3797 3.47447C11.6971 3.47447 11.9544 3.76074 11.9545 4.11402L11.9546 11.9964C11.9541 12.1731 11.8901 12.3334 11.7861 12.4491C11.7191 12.5236 11.6358 12.5799 11.5426 12.6103C11.49 12.6278 11.4344 12.6372 11.3767 12.637L4.29316 12.6377C3.97565 12.6376 3.71834 12.3513 3.71831 11.9981C3.71831 11.645 3.97565 11.3587 4.29316 11.3586L9.9943 11.3586Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonal);
export default __webpack_public_path__ + "static/media/arrow-diagonal.5cd9ee9f5722220efd9ee952d5ef6b0a.svg";
export { ForwardRef as ReactComponent };